module.exports = __webpack_public_path__ + "img/distributed-magic.4c79fb67.jpg";